import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

const initialState = {
  dataByType: {},       
  loading: false,
  error: null
};

export const fetchSubCategory = createAsyncThunk(
  "subcategory/fetch",
  async ({ type }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(
        "/api/admin/sub-categories",
        { params: { type } }
      );
      return { type, data: res.data?.data || [] };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch sub-categories"
      );
    }
  }
);

// CREATE
export const createSubCategory = createAsyncThunk(
  "subcategory/create",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/api/admin/sub-categories",
        formData
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to create sub-category"
      );
    }
  }
);


export const updateSubCategory = createAsyncThunk(
  "subcategory/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `/api/admin/sub-categories/${id}`,
        formData
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update sub-category"
      );
    }
  }
);


export const deleteSubCategory = createAsyncThunk(
  "subcategory/delete",
  async ({ id, type }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(
        `/api/admin/sub-categories/${id}`
      );
      return { id, type };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete sub-category"
      );
    }
  }
);



const subCategorySlice = createSlice({
  name: "subcategory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* FETCH */
      .addCase(fetchSubCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.dataByType[action.payload.type] = action.payload.data;
      })
      .addCase(fetchSubCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* CREATE */
      .addCase(createSubCategory.fulfilled, (state, action) => {
        const type = action.payload.type;
        if (!state.dataByType[type]) {
          state.dataByType[type] = [];
        }
        state.dataByType[type].push(action.payload);
      })

      /* UPDATE */
      .addCase(updateSubCategory.fulfilled, (state, action) => {
        const type = action.payload.type;
        state.dataByType[type] = state.dataByType[type]?.map((sc) =>
          sc.id === action.payload.id ? action.payload : sc
        );
      })

      /* DELETE */
      .addCase(deleteSubCategory.fulfilled, (state, action) => {
        const { id, type } = action.payload;
        state.dataByType[type] =
          state.dataByType[type]?.filter(sc => sc.id !== id);
      });
  }
});

export default subCategorySlice.reducer;